export default __webpack_public_path__ + "static/1-8bb3483358a5c7fce4b9c0adac843d88.webp";